<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="120px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="版本名称">
            <el-input
              v-model="queryForm.versionName"
              placeholder="请输入版本名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker
              v-model="dialogForm.dateRange"
              align="right"
              type="daterange"
              placeholder="选择日期"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="dateChange"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
            <el-button @click="handleAdd" icon="el-icon-plus" type="success" v-hasPermi="['Island:version:add']"
              >新增</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="版本名称"
          prop="psp_order_id"
          height="500"
        />
        <el-table-column
          align="center"
          label="版本号"
          prop="finish_time"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="finish_time"
          label="备注内容"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="refund_time"
          label="是否强制更新"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column align="center" label="操作" width="280">
          <template #default="{ row }">
            <el-button
              size="small"
              type="primary"
              v-hasPermi="['Island:version:edit']"
              @click="handleEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              v-hasPermi="['Island:version:delete']"
              @click="handleDelete(row)"
              >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getList } from "@/api/order";

export default {
  data() {
    return {
      businessList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      queryForm: {
        page: 1,
        pageSize: 10,

        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
      }, // 搜索条件表单
      dialogVisible: false, // 模态框是否展示
      dialogForm: {
        versionName: '',
        dateRange: ''
      }, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      tableData: [],
      start: '',
      end: '',
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {},

  methods: {
    dateChange(val) {
      if(val){
        const [start, end] = val
        this.start = start + ' 00:00:00'
        this.end = end + ' 23:59:59'
      } else {
        this.start = ''
        this.end = ''
      }
    },
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleQuery() {
      this.queryForm.page = 1;
      this.fetchData();
    },
    handleAdd(){
    },
    async fetchData() {
      // 这里发请求
      let params = {
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
      };
      console.log(params);
      // await getList(params)
      //   .then((res) => {
      //     if (res && res.code) {
      //       this.tableData = res.data.data_list
      //       this.total = res.data.total_record
      //     }
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //   });
    },
    handleDelete(row) {

    },
    handleEdit(row) {

    },
  },
};
</script>
<style lang="scss" scoped>
.tableCard {
  margin-top: 20px;
}
.el-pagination {
  text-align: center;
  margin-top: 10px;
}

</style>